"use client";

import { ChevronRightIcon, Loader2Icon } from "lucide-react";
import { useEffect, useState } from "react";

type Tenant = {
  id: string;
  name: string;
};

export function PickTenant() {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [loading, setLoading] = useState(true);

  const sp = new URLSearchParams(window.location.search);

  const pickTenant = async (id: string) => {
    const redirectUri = sp.get("redirectUri") ?? "/";
    const params = new URLSearchParams();
    params.set("redirect-uri", redirectUri);
    params.set("tenant-id", id);

    await fetch("/pick-tenant?" + params.toString(), {
      method: "POST",
      credentials: "include",
      redirect: "manual",
    });

    window.location.href = redirectUri;
  };

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const params = new URLSearchParams();
        const clientId = new URLSearchParams(window.location.search).get(
          "clientId",
        );
        if (clientId) params.set("clientId", clientId);

        const res = await fetch("/get-tenant?" + params.toString());
        if (!res.ok) throw new Error("HTTP " + res.status);

        const data: Tenant[] = await res.json();

        // Auto-skip if only one tenant
        if (data.length === 1) {
          if (!data[0].id) return;

          await pickTenant(data[0]?.id);
          return;
        }

        setTenants(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTenants();
  }, [pickTenant]);

  if (loading || tenants.length === 0) {
    return (
      <div className="flex items-center justify-center h-dvh">
        <Loader2Icon
          className="animate-spin text-jacksons-purple-600"
          size={28}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 justify-center items-center h-dvh w-full relative">
      <title>Vyberte společnost</title>

      <h1 className="text-xl mb-4 font-semibold">Vyberte společnost</h1>
      {tenants.map((t) => {
        const initials = t.name
          .split(" ")
          .map((w) => w[0])
          .slice(0, 2)
          .join("")
          .toUpperCase();

        return (
          <button
            key={t.id}
            onClick={() => pickTenant(t.id)}
            className="group flex items-center justify-between w-96 px-4 py-3.5 bg-white border border-border rounded-xl hover:bg-accent hover:border-border/80 transition-all active:scale-[0.985] text-left"
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-blue-50 text-blue-700 text-[13px] font-medium flex items-center justify-center shrink-0">
                {initials}
              </div>
              <div>
                <p className="text-[15px] font-medium text-foreground leading-tight">
                  {t.name}
                </p>
                {/* <p className="text-xs text-muted-foreground mt-0.5">
                  {t.id}
                </p> */}
              </div>
            </div>
            <ChevronRightIcon
              size={18}
              className="text-muted-foreground/50 group-hover:text-muted-foreground group-hover:translate-x-0.5 transition-all shrink-0"
            />
          </button>
        );
      })}
      <span className="absolute bottom-2 text-xs text-muted-foreground">
        ©{new Date().getFullYear()} QONIQO s.r.o.
      </span>
    </div>
  );
}
